import React from "react";
import {
  Box,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import {
  ColumnDef,
  getCoreRowModel,
  flexRender,
  RowData,
  useReactTable,
} from "@tanstack/react-table";

declare module "@tanstack/react-table" {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface TableMeta<TData extends RowData> {
    updateData: (rowIndex: number, columnId: string, value: number) => void;
  }
}

export type DataType = {
  parameter: string;
  category: string;
} & Record<string, number>;

export type ColumnType = ColumnDef<DataType>;

type PropsType = {
  data: DataType[];
  columns: ColumnType[];
  updateData: (rowIndex: number, columnId: string, value: number) => void;
  deleteColumn?: (columnId: string) => void;
};

const PrioritySettingsTable: React.FC<PropsType> = ({
  data,
  columns,
  updateData,
}) => {
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    meta: { updateData },
  });

  let currentCategory = "";

  return (
    <TableContainer
      sx={{ border: "1px solid #ddd", borderRadius: 1, overflow: "hidden" }}
    >
      <Table size="small">
        <TableHead
          sx={{ backgroundColor: "var(--header)", color: "var(--white)" }}
        >
          {table.getHeaderGroups().map((hg) => (
            <tr key={hg.id}>
              {hg.headers.map((header) => (
                <th key={header.id}>
                  <Box display="flex" alignItems="center" gap={0.5}>
                    {flexRender(
                      header.column.columnDef.header,
                      header.getContext(),
                    )}
                  </Box>
                </th>
              ))}
            </tr>
          ))}
        </TableHead>
        <tbody>
          {table.getRowModel().rows.map((row) => {
            const showCategoryHeader =
              row.original.category !== currentCategory;
            currentCategory = row.original.category;
            return (
              <React.Fragment key={row.id}>
                {showCategoryHeader && (
                  <TableRow sx={{ backgroundColor: "#f0f0f0" }}>
                    <TableCell
                      colSpan={columns.length}
                      sx={{ fontWeight: "medium" }}
                    >
                      {currentCategory}
                    </TableCell>
                  </TableRow>
                )}
                <TableRow hover>
                  {row.getVisibleCells().map((cell) => (
                    <TableCell key={cell.id} sx={{ py: 2 }}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext(),
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </React.Fragment>
            );
          })}
        </tbody>
      </Table>
    </TableContainer>
  );
};

export default PrioritySettingsTable;
